import { roundTo3Decimal } from "../../Utils";

export function prepareDaysReport(reportRaw) {
    const days = [];
    const keysObj = {};
    let currIndex = 0;

    const report = reportRaw.reduce((arr, { day, country, device, ...obj }) => {
        obj.eCost = roundTo3Decimal(calculateECost(obj.spends, obj.conversions));

        const key = `${country}:${device}`;
        const index = keysObj[key];

        if(index === undefined) {
            arr.push({ country, device, daysData: { [day]: obj} });
            keysObj[key] = currIndex++;
        }
        else arr[index].daysData[day] = obj;

        if(days.indexOf(day) === -1) days.push(day);

        return arr;
    }, []);

    return { report, days };
}

export function preparePeriodReport(reportRaw) {
    const keysObj = {};
    let currIndex = 0;

    const report = reportRaw
        .reduce((arr, { country, device, spends, conversions }) => {
            if(!spends) spends = 0;
            if(!conversions) conversions = 0;

            const key = `${country}:${device}`;
            const index = keysObj[key];

            if(index === undefined) {
                arr.push({ country, device, spends, conversions });
                keysObj[key] = currIndex++;
            }
            else {
                if(spends) arr[index].spends = arr[index].spends + spends;
                if(conversions) arr[index].conversions = arr[index].conversions + conversions;
            }

            return arr;
        }, [])
        .map(obj => {
            obj.eCost = roundTo3Decimal(calculateECost(obj.spends, obj.conversions));
            obj.spends = roundTo3Decimal(obj.spends);

            return obj;
        });

    return { report};
}

export function calculateECost(spends, conversions) {
    return spends && conversions ? spends / conversions : 0;
}


// WEBPACK FOOTER //
// ./src/scenes/BidderECostCountry/prepareReport.js